import React from 'react';

import { ReactComponent as FacebookIcon } from '../../../assets/icons/newFacebook.svg';
import { ReactComponent as Linkedin } from '../../../assets/icons/newLinkedin.svg';
import { ReactComponent as Twitter } from '../../../assets/icons/Twitter.svg';
import { Typography } from '../../../designComponents';
import { SocialLink, SocialStyledContainer } from './style';

type Props = {};

const Social = (_props: Props) => {
  return (
    <SocialStyledContainer>
      <Typography className="title" size={16} fontColor="white">
        Social Media
      </Typography>
      <Typography fontColor="white" size={14} style={{ marginBottom: '10px' }}>
        Follow us on our social media to find out the latest updates on our
        progress.
      </Typography>
      <SocialLink>
        <FacebookIcon />
        <Linkedin />
        <Twitter />
      </SocialLink>
    </SocialStyledContainer>
  );
};

export default Social;
